import APIs from '../../apiUrl';

const ShopServices = {
  SearchProducts: async ({
    name = 'all',
    category = 'all',
    brand = 'all',
    from = 0,
    to = 0,
    page = 0,
    limit = 10,
  }) => {
    try {
      const url = `/search_for_product_by_category/${name}/${category}/${brand}/${from}/${to}/${page}/${limit}`;

      const response = await APIs.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default ShopServices;
